import React from "react";
import styled, { css } from "styled-components";
import * as _ from "lodash";

import { ITerminology } from "src/library/utils";
import { Text } from "src/library/components/Text";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";

import { IProductCategory } from "../api/products.api";
import { CategoryChildRow } from "./CategoryChildRow";

export interface CategoryUneditableCardProps extends Pick<IProductCategory, "name"> {
  terminology: ITerminology;
  childCategories: IProductCategory[];
}

/**
 * Plain category uneditable row, includes rendering category children via toggle if present
 *
 * @returns a category row react element
 */
export const CategoryUneditableCard: React.ReactFCWithChildren<CategoryUneditableCardProps> = ({
  name,
  childCategories,
  terminology
}) => {
  const [ showChildren, setShowChildren ] = React.useState(false);

  return (
    <>
      <RowWrapper>
        <div className="icon-wrapper">
          {!!childCategories.length && (
            <Icon
              icon={showChildren ? Icons.CHEVRONUP : Icons.CHEVRONDOWN}
              onClick={() => setShowChildren(!showChildren)}
            />
          )}
        </div>

        <Text>
          {name}
        </Text>
      </RowWrapper>

      {showChildren && _.map(childCategories, childCategory => (
        <div key={`child-category-${childCategory.id}`}>
          <CategoryChildRow
            id={childCategory.id}
            name={childCategory.name}
            terminology={terminology}
            hideActions
          />
        </div>
      ))}
    </>
  );
};

const RowWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    align-items: center;
    background: ${theme.colors.white};
    padding: ${theme.spacing.padding.sm} ${theme.spacing.padding.md}; 
    border-bottom: ${theme.colors.lightGrey} 1px solid;
    height: 45px;

    .icon-wrapper {
      width: 30px;

      svg:hover {
        cursor: pointer;
      }
    }
  `}
`;
